"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsKira = void 0;
const react_query_1 = require("react-query");
const useCirrus_1 = require("./useCirrus");
function useIsKira(locationId) {
    var _a;
    const { socket } = useCirrus_1.useCirrus();
    const { data } = react_query_1.useQuery(['is-kira', locationId, socket.id], () => {
        return socket.request({
            messageType: 'GetPropertyRequest',
            address: {
                resourceType: 'LocationAddress',
                timeCreated: Date.now(),
                locationId,
            },
            name: 'locationType',
        });
    }, { cacheTime: 5 * 60 * 1000, staleTime: 5 * 60 * 1000 });
    const locationTypeProperty = (data === null || data === void 0 ? void 0 : data.messageType) === 'GetPropertyResponse' && ((_a = data.list) === null || _a === void 0 ? void 0 : _a.find((x) => x.name === 'locationType'));
    const isKira = !!locationTypeProperty && locationTypeProperty.value === 'kira';
    return isKira;
}
exports.useIsKira = useIsKira;
//# sourceMappingURL=useIsKira.js.map